module.exports = __webpack_public_path__ + "static/img/faeroe.4271947.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/faeroe.jpg
// module id = 4QZi
// module chunks = 1